<template>
  <el-dialog
    :title="$t('affiliateRuleManage.add')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form
      :model="addAffiliateRuleInfo"
      :rules="rules"
      ref="addForm"
      label-width="150px"
    >
      <el-form-item
        :label="$t('affiliateRuleManage.ruleName')"
        prop="name"
      >
        <el-input
          v-model="addAffiliateRuleInfo.name"
          :placeholder="$t('affiliateRuleManage.ruleNamePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('affiliateRuleManage.level1Rate')"
        prop="level1Rate"
      >
        <el-input
          v-model="addAffiliateRuleInfo.level1Rate"
          :placeholder="$t('affiliateRuleManage.level1RatePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('affiliateRuleManage.level2Rate')"
        prop="level2Rate"
      >
        <el-input
          v-model="addAffiliateRuleInfo.level2Rate"
          :placeholder="$t('affiliateRuleManage.level2RatePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('affiliateRuleManage.level21Rate')"
        prop="level21Rate"
      >
        <el-input
          v-model="addAffiliateRuleInfo.level21Rate"
          :placeholder="$t('affiliateRuleManage.level21RatePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('affiliateRuleManage.expireDay')"
        prop="expireDay"
      >
        <el-input
          v-model="addAffiliateRuleInfo.expireDay"
          :placeholder="$t('affiliateRuleManage.expireDayPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveAffiliateRuleInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveAffiliateRule } from '@/api/affiliate/affiliateRuleApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddAffiliateRule',
  data() {
    return {
      dialogVisible: false,
      addAffiliateRuleInfo: {
        name: '',
        level1Rate: '',
        level2Rate: '',
        level21Rate: '',
        expireDay: '',
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('affiliateRuleManage.ruleNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('affiliateRuleManage.ruleNameMaxLength'), trigger: 'blur' }
        ],
        level1Rate: [
          { required: true, message: this.$t('affiliateRuleManage.level1RateRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('affiliateRuleManage.level1RateMaxLength'), trigger: 'blur' }
        ],
        level2Rate: [
          { required: true, message: this.$t('affiliateRuleManage.level2RateRequired'), trigger: 'blur' }
        ],
        level21Rate: [
          { required: true, message: this.$t('affiliateRuleManage.level21RateRequired'), trigger: 'blur' }
        ],
        expireDay: [
          { required: true, message: this.$t('affiliateRuleManage.expireDayRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('affiliateRuleManage.expireDayMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.addAffiliateRuleInfo.shopId = getShopId()
    },
    handleClose() {
      this.$refs.addForm.resetFields()
    },
    saveAffiliateRuleInfo() {
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          try {
            await saveAffiliateRule(this.addAffiliateRuleInfo)
            this.$message.success(this.$t('affiliateRuleManage.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>